import Products from "./data/products";
import Loader, { LoaderEvents } from "./loader";
import { AppBase } from "./appBase";
import PgProduct from "./entities/pgProduct";
import templates from "bundle-text:../templates/ts-product.html";
import { appUtils } from ".";

class AppProduct extends AppBase {
    private _products: Products;
    private _ui: PgProduct;
    private _templates: { [tag: string]: string; };

    get products() { return this._products; }
    get templates() { return this._templates; }
    get ui() { return this._ui; }

    constructor() {
        super();
        this._loader = new Loader();
        this._products = new Products(this.loader);
        this._templates = appUtils.tagsToStrMap(templates);
    }

    override _init() {
        this._langs.init();
        this._header.init();
        this._ui = new PgProduct();

        this._loader.once(LoaderEvents.Complete, () => this._onLoadDone())
            .load(false);
    }

    private _onLoadDone(): void {
        window.addEventListener("mousemove", e => this._onMouseMove(e));

        this._ui.init();
        this._loader.once(LoaderEvents.Complete, () => {
            document.documentElement.classList.remove("loading");
            this._animateDom();
        })
    }
}

export const app = new AppProduct();